import i18n from 'utils/package';
import { getCurrency, formatPriceCurrency } from 'utils/utils';
import { FlightDetails } from '../interfaces/FlightDetailsResponse';
import { Select } from 'ts/interfaces/Generic';

export class BookOptionsCatalogue {
  outboundBaggage: BoundOptions;
  outboundMeal: BoundOptions;

  visible: boolean;
  constructor(baggageFlights?: FlightDetails[]) {
    this.outboundBaggage = {
      label: '',
      options: [],
      visible: false,
      paxTypes: [],
    };
    this.outboundMeal = {
      label: '',
      options: [],
      visible: false,
      paxTypes: [],
    };

    baggageFlights?.forEach((flight) => {
      if (flight?.outbound?.listOfCatalogPrice?.length) {
        const outboundBaggage = flight.outbound.listOfCatalogPrice
          .filter((catalog) => catalog.type === 'BAG')
          .map((catalog) => {
            if (!this.outboundBaggage.paxTypes.includes(catalog.paxType)) {
              this.outboundBaggage.paxTypes.push(catalog.paxType);
              if (catalog.paxType === 0) {
                this.outboundBaggage.paxTypes.push(2);
              }
            }

            const price = formatPriceCurrency(
              catalog.displayPrice.value,
              getCurrency(catalog.displayPrice.currency)
            );
            const label = catalog.desc;
            return {
              label: `${price} - ${label}`,
              value: catalog.code,
            };
          });

        this.outboundBaggage.options.push(...outboundBaggage);
        this.outboundBaggage.label = `${i18n.t('filter.baggage')}: [${
          flight.outbound.departureAirport.cityDesc
        }  → ${flight.outbound.arrivalAirport.cityDesc}]`;
        this.outboundBaggage.visible = !!outboundBaggage.length;

        const outboundMeal = flight.outbound.listOfCatalogPrice
          .filter((catalog) => catalog.type === 'MEAL')
          .map((catalog) => {
            if (!this.outboundMeal.paxTypes.includes(catalog.paxType)) {
              this.outboundMeal.paxTypes.push(catalog.paxType);
              if (catalog.paxType === 0) {
                this.outboundMeal.paxTypes.push(2);
              }
            }
            const price = formatPriceCurrency(
              catalog.displayPrice.value,
              getCurrency(catalog.displayPrice.currency)
            );
            const label = catalog.desc;
            return {
              label: `${price} - ${label}`,
              value: catalog.code,
            };
          });

        this.outboundMeal.options.push(...outboundMeal);
        this.outboundMeal.label = `${i18n.t('filter.meal')}: [${
          flight.outbound.departureAirport.cityDesc
        }  → ${flight.outbound.arrivalAirport.cityDesc}]`;
        this.outboundMeal.visible = !!outboundMeal.length;
      }
    });

    this.visible = this.outboundBaggage.visible || this.outboundMeal.visible;
  }
}

interface BoundOptions {
  label: string;
  options: Select[];
  visible: boolean;
  paxTypes: number[];
}
